import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const patientInfo = {
    cardNo: '',
    cardType: '',
    cardTypeDesc: '',
    patientId: '',
    idNo: '',
    name: '',
    outPatientBalance: '',
    openId: '',
}

const reportQueryInfo = {
    patientId: '',
    type: '',
    patientName: '',
}

const inhospitalPatientInfo = {
    cardNo: '',
    cardType: '',
    idNo: '',
    name: '',
    hospitalNo: '',
    visitId: '',
    inHospitalBalance: '',
    bedNo: '',
    dept: '',
}

const mzPricePayInfo = {
    clinicNO: "",
    recipeNO: "",
    deptName: "",
    doctName: "",
    fee: ""
}

const registInfo = {
    deptId: '',
    deptName: '',
    doctorId: '',
    doctorName: '',
    rank: '',
    date: '',
    fee: '',
    schemaID: '',
    time: '',
}

const tradeInfo = {
    paymentType: "",
    money: "",
    desc: "",
    bussiness: ""
}

const onlineData = {
    searchDeptId: "",
    searchContent: "",
    consultation: {},
}

export default new Vuex.Store({
    state: {
        Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
        patientInfo,
        mzPricePayInfo,
        inhospitalPatientInfo,
        reportQueryInfo,
        registInfo,
        tradeInfo,
        openId: localStorage.getItem('openId') ? localStorage.getItem('openId') : '',
        onlineData,
        payFlag: '',
        staticDir: "http://www.ylfybjy.cn/upFiles",
        serviceAddress: "http://www.ylfybjy.cn",
    },
    mutations: {
        setOnlineData(state, onlineData){
            state.onlineData = onlineData;
        },
        setPayFlag(state, payFlag){
            state.payFlag = payFlag;
        },
        saveToken(state, token) {
            state.Authorization = token;
            localStorage.setItem('Authorization', token);
        },
        setOpenId(state, openId){
            state.openId = openId;
            state.patientInfo.openId = openId;
            localStorage.setItem('openId', openId);
        },
        setPatientInfo(state, patientInfo){
            state.patientInfo = patientInfo;
        },

        setReportQueryInfo(state, reportQueryInfo){
            state.reportQueryInfo = reportQueryInfo;
        },

        setInhospitalPatientInfo(state, inhospitalPatientInfo){
            state.inhospitalPatientInfo = inhospitalPatientInfo;
        },

        setRegistInfo(state, registInfo){
            state.registInfo = registInfo;
        },
        setMzPricePayInfo(state, mzPricePayInfo){
            state.mzPricePayInfo = mzPricePayInfo;
        },
        clearMzPricePayInfo(state){
            let mzPricePayInfo = {
                clinicNO: "",
                recipeNO: "",
                deptName: "",
                doctName: "",
                fee: ""
            }
            state.mzPricePayInfo = mzPricePayInfo;

            let tradeInfo = {
                paymentType: "",
                money: "",
                desc: "",
                bussiness: ""
            }
            state.tradeInfo = tradeInfo;
        },
        setTradeInfo(state, tradeInfo){
            state.tradeInfo = tradeInfo;
        },
    },
})
